(() => {
  const runtimeKey = 'DilmahSeasonalFlushBanner';
  if (window[runtimeKey]) {
    window[runtimeKey].scan();
    return;
  }

  const selector = '[data-sf-banner]';
  const second = 1000;
  // Same rule as the Liquid: an explicit offset (or Z) pins one instant for every visitor.
  const isoWithOffset = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?(Z|[+-]\d{2}:\d{2})$/;

  /** @param {string} value @returns {number} epoch ms, or NaN when missing/invalid */
  const parseStart = (value) => (isoWithOffset.test(value.trim()) ? Date.parse(value.trim()) : NaN);

  /** @param {number} ms */
  const split = (ms) => {
    const total = Math.max(0, Math.ceil(ms / second));
    return {
      days: Math.floor(total / 86400),
      hours: Math.floor((total % 86400) / 3600),
      minutes: Math.floor((total % 3600) / 60),
      seconds: total % 60,
    };
  };

  const pad = (value) => String(Math.max(0, value)).padStart(2, '0');

  /** @param {HTMLElement} root */
  const finish = (root) => {
    root.setAttribute('data-finished', '');
    if (root.dataset.hideWhenFinished === 'true') {
      root.hidden = true;
      return;
    }
    root.querySelector('[data-sf-banner-countdown]')?.setAttribute('hidden', '');
    root.querySelector('[data-sf-banner-finished-message]')?.removeAttribute('hidden');
    const cta = root.querySelector('[data-sf-banner-cta]');
    if (!(cta instanceof HTMLAnchorElement)) return;
    if (cta.dataset.finishedLabel) cta.textContent = cta.dataset.finishedLabel;
    if (cta.dataset.finishedUrl) cta.href = cta.dataset.finishedUrl;
  };

  const init = (root) => {
    if (!(root instanceof HTMLElement) || root._sfBannerStop) return;
    const start = parseStart(root.dataset.startAt || '');
    const countdown = root.querySelector('[data-sf-banner-countdown]');
    let timer = 0;
    const stop = () => {
      window.clearInterval(timer);
      timer = 0;
    };
    root._sfBannerStop = () => {
      stop();
      delete root._sfBannerStop;
    };

    if (Number.isNaN(start)) {
      countdown?.setAttribute('hidden', '');
      return;
    }

    const nodes = countdown ? Array.from(countdown.querySelectorAll('[data-unit]')) : [];
    const tick = () => {
      const remaining = start - Date.now();
      const values = split(remaining);
      nodes.forEach((node) => {
        node.textContent = pad(values[node.dataset.unit]);
      });
      if (remaining <= 0) {
        stop();
        finish(root);
      }
    };

    tick();
    if (start > Date.now()) timer = window.setInterval(tick, second);
  };

  const scan = (scope = document) => scope.querySelectorAll(selector).forEach(init);

  window[runtimeKey] = { scan, parseStart, split };

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selector).forEach((root) => root._sfBannerStop?.());
  });
  document.addEventListener('shopify:section:load', (event) => scan(event.target));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
})();
